export const VALIDATION_PATTERNS = {
  SIREN: /^[0-9]{9}$/,
  SIRET: /^[0-9]{14}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[0-9\s+()-]{10,}$/,
  URL: /^https?:\/\/.+/,
} as const;

export const EMAIL_REGEX = VALIDATION_PATTERNS.EMAIL;
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;

export const PASSWORD_CRITERIA = {
  minLength: PASSWORD_MIN_LENGTH,
  hasLowercase: /[a-z]/,
  hasUppercase: /[A-Z]/,
  hasNumber: /\d/,
  hasSpecialChar: /[@$!%*?&#]/,
} as const;

export const validateSiretMatchesSiren = (siret: string, siren: string): boolean => {
  if (!siret || !siren) return true;
  return siret.startsWith(siren);
};
